import table from './price-baseline-es.json';
import { matchIngredient } from './recipeProposal';
import { dimensionOf, toBase, type Unit } from './units';

export interface PriceEstimate {
  unitPrice: number;
  unit: Unit;
  basis: 'tabla' | 'alexia';
  at: string;
}

export const PRICE_BASELINE_DATE = table.at;
const catalog = table.entries.map((item, index) => ({ ingredientId: String(index), name: item.name, purchaseUnit: item.unit as Unit }));

/** Solo España/EUR. Nunca elige entre coincidencias ambiguas ni convierte peso en piezas. */
export function estimatePrice(name: string, unit: Unit, country: string, currency = 'EUR'): PriceEstimate | null {
  if (country.toUpperCase() !== 'ES' || currency !== 'EUR') return null;
  const match = matchIngredient(name, catalog);
  if (match.kind !== 'exact' && match.kind !== 'fuzzy') return null;
  const entry = table.entries[Number(match.candidates[0].ingredientId)];
  if (dimensionOf(unit) !== dimensionOf(entry.unit as Unit)) return null;
  return { unitPrice: entry.unitPrice * toBase(1, unit) / toBase(1, entry.unit as Unit), unit, basis: 'tabla', at: table.at };
}
